import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import cn from 'classnames';
import isEqual from 'lodash/isEqual';

import {
  EmptyState,
  FilterButton,
  LimitPaginationButton,
  Loading,
  PageTitle,
  PaginationGroup,
  SaveFilterBlock,
  TableColumnSetting,
  TableTitle,
  Text
} from 'components/common/Elements/Elements';
import { modalActionBody } from 'components/common/Elements/NewModal/newModal';
import { closeModal } from '@p81-common/ui';
import InputSearch from 'components/common/forms/InputSearch/InputSearch';
import { useRegionPersistedSearch } from 'contexts/SearchPersistenceContext';
import AgentInfo from './parts/AgentInfo/AgentInfo';
import RolloutCustomersTable from './parts/RolloutCustomersTable/RolloutCustomersTable';
import ResultAlert from './parts/ResultAlert/ResultAlert';
import FiltersBlock from './parts/FiltersBlock/FiltersBlock';
import FooterModalCustomers from './parts/FooterModalCustomers/FooterModalCustomers';

import {
  defaultFilters,
  defaultNavigation,
  mainTableConf
} from './helpers/configurates';
import { createReqBody } from './helpers/helpers';
import {
  RELEASE_TRACKS,
  defaultFilters as versionsDefaultFilters,
  defaultNavigation as versionsDefaultNavigation
} from '../RolloutVersions/helpers/configurates';
import { createReqBody as createVersionsReqBody } from '../RolloutVersions/helpers/helpers';
import { getRequest, postRequest } from 'utils/requests';
import {
  checkingForExistenceOfOptions,
  clearOrDefaultFilters,
  paddingForMenuSettings,
  parsConfigForHistory,
  reParsConfigForHistory,
  replaceHistory
} from 'utils/common';
import { getAxiosErrorMessage } from 'utils/errors';
import { hide, showNotif } from 'utils/notification';
import { validationNumber } from 'utils/validation';
import { showNotif as newShowNotif } from '@p81-common/ui';

import classes from './RolloutCustomers.module.scss';

const RolloutCustomers = () => {
  const location = useLocation();
  const [agent] = useState(location.state ? location.state.agent : '');
  const [buildIds] = useState(location.state ? location.state.buildIds : '');

  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [trackHolders, setTrackHolders] = useState([]);
  //   filters and pagination
  const [filter, setFilter] = useState({
    ...defaultFilters,
    ...defaultNavigation
  });

  const [filterBackend, setFilterBackend] = useState({
    key: 'rollCustFilter',
    value: []
  });
  const [visibleFilterSave, setVisibleFilterSave] = useState(false);
  const [visibleFilterEdit, setVisibleFilterEdit] = useState(false);
  const [changeFilter, setChangeFilter] = useState('Default');
  const [trigerResetDatePicker, setTrigerResetDatePicker] = useState(false);

  const [filterButton, setFilterButton] = useState(false);
  const [tableConf, setTableConf] = useState(
    JSON.parse(JSON.stringify(mainTableConf))
  );

  //data from api
  const [data, setData] = useState({});
  const [filters, setFilters] = useState({});

  //other data
  const [loader, setLoader] = useState(true);
  const [loaderTable, setLoaderTable] = useState(false);
  const [dataConection, setDataConection] = useState(false);
  const [selectLoader, setSelectLoader] = useState(false);

  // if you touch this trigger, then a request for filter lists is sent
  const [startFilter, setStartFilter] = useState(false);
  // status for comparison whether new options have been selected
  const [prevStateFilter, setPrevStateFilter] = useState();
  const [prevStateTableConf, setPrevStateTableConf] = useState();

  const [triggerSaveTableSettings, setTriggerSaveTableSettings] =
    useState(false);
  const [triggerStartEffect, setTriggerStartEffect] = useState(false);
  // const [enabledRequest, setEnabledRequest] = useState(true);

  const { t } = useTranslation(['activity']);

  const history = useHistory();
  const query = new URLSearchParams(history.location.search);

  const tableHeight = useRef();
  const unmount = useRef(false);

  const handleCheckCustomer = company => {
    if (
      !selectedCustomers.find(item => item.customerId === company.customerId)
    ) {
      setSelectedCustomers([...selectedCustomers, company]);
    } else {
      setSelectedCustomers(
        selectedCustomers.filter(item => item.customerId !== company.customerId)
      );
    }
  };

  const isSelectedCustomer = customerId => {
    return selectedCustomers.find(item => item.customerId === customerId);
  };

  const handleChekBox = () => {
    if (selectedCustomers.length > 0) {
      setSelectedCustomers([]);
    } else {
      setSelectedCustomers([...data.data]);
    }
  };

  const handleCancel = () => {
    modalActionBody({
      title: 'Cancel Rollout Version',
      callBack: () => history.push('/cs/agent-rollout'),
      text: (
        <Text>
          Are you sure you want to cancel rollout the following version:{' '}
          <Text type="s" className={cn(classes.bold, classes.bold_capitalize)}>
            {agent.platform}
            {agent.platform === 'linux'
              ? ` - ${
                  agent.files.find(item => item.buildId === buildIds[0]).osDist
                }`
              : ''}
          </Text>{' '}
          <Text type="s" className={classes.bold}>
            {agent.arch}
          </Text>{' '}
          <Text type="s" className={cn(classes.bold, classes.bold_capitalize)}>
            {agent.version}
          </Text>{' '}
          to the{' '}
          <Text type="s" className={classes.bold}>
            {selectedCustomers.length > 0
              ? selectedCustomers.length
              : testToIsNotFiltered()
              ? 'All Tenants'
              : 'All Filtered Tenants'}
          </Text>
          {selectedCustomers.length > 0 && ' following customers'}?
        </Text>
      )
    });
  };

  const handleRollout = () => {
    modalActionBody({
      title: 'Rollout Version Summary',
      callBack: () => handlePostRollout(),
      text: (
        <Text>
          Are you sure you want to rollout the following version:{' '}
          <Text type="s" className={cn(classes.bold, classes.bold_capitalize)}>
            {agent.platform}
            {agent.platform === 'linux'
              ? ` - ${
                  agent.files.find(item => item.buildId === buildIds[0]).osDist
                }`
              : ''}
          </Text>{' '}
          <Text type="s" className={classes.bold}>
            {agent.arch}
          </Text>{' '}
          <Text type="s" className={cn(classes.bold, classes.bold_capitalize)}>
            {agent.version}
          </Text>{' '}
          to the{' '}
          <Text type="s" className={classes.bold}>
            {selectedCustomers.length > 0
              ? selectedCustomers.length
              : testToIsNotFiltered()
              ? 'All Tenants'
              : 'All Filtered Tenants'}
          </Text>
          {selectedCustomers.length > 0 && ' following customers'}?
        </Text>
      ),
      okText: 'Rollout',
      cancelText: t('activity:featureFlag.NO_THANKS')
    });
  };

  const handleSetAsDefault = async () => {
    const requestUrl = '/cs/agents/set-default-for-new-tenants';

    const body = {
      platform: agent.platform,
      buildIds
    };
    try {
      const result = await postRequest(requestUrl, body);
      newShowNotif(t('activity:agentRollout.SET_AS_DEFAULT_SUCCESS_MESSAGE'), {
        alertProps: {
          severity: 'success',
          variant: 'filled',
          style: { width: 'max-content' }
        }
      });
      return result;
    } catch (err) {
      console.log(err);
      newShowNotif(
        err.response.data.message || t('activity:ROLES.FAILURE_MESSAGE'),
        {
          alertProps: {
            severity: 'error',
            variant: 'filled',
            style: { width: 'max-content' }
          }
        }
      );
      return err;
    }
  };

  const handleSetVersionTrack = async track => {
    const requestUrl = '/cs/agents/set-version-track';

    const body = {
      platform: agent.platform,
      track,
      buildIds
    };

    try {
      const result = await postRequest(requestUrl, body);
      newShowNotif(
        t('activity:agentRollout.SET_VERSION_TRACK_SUCCESS_MESSAGE'),
        {
          alertProps: {
            severity: 'success',
            variant: 'filled',
            style: { width: 'max-content' }
          }
        }
      );
      return result;
    } catch (err) {
      console.log(err);
      newShowNotif(
        getAxiosErrorMessage(err) ||
          t('activity:agentRollout.SET_VERSION_TRACK_FAILURE_MESSAGE'),
        {
          alertProps: {
            severity: 'error',
            variant: 'filled',
            style: { width: 'max-content' }
          }
        }
      );
      return err;
    }
  };

  const testToIsNotFiltered = () =>
    isEqual(
      { ...filter, ...defaultNavigation },
      {
        ...defaultFilters,
        ...defaultNavigation
      }
    );

  const handlePostRollout = () => {
    const linkForRequest = `/cs/agents/release`;

    const resultData = {
      count: selectedCustomers.length,
      version: agent.version,
      platform: agent.platform,
      arch:
        agent.platform === 'linux'
          ? ` - ${
              agent.files.find(item => item.buildId === buildIds[0]).osDist
            }`
          : '',
      isNotFiltered: testToIsNotFiltered()
    };

    const arrTenantsId = selectedCustomers.map(customer => customer.customerId);

    const REQ_BODY =
      arrTenantsId.length > 0
        ? {
            agentIds: buildIds,
            tenants: arrTenantsId
          }
        : testToIsNotFiltered()
        ? {
            agentIds: buildIds,
            allTenants: true
          }
        : {
            agentIds: buildIds
          };
    postRequest(linkForRequest, REQ_BODY)
      .then(() => {
        closeModal();
        if (!unmount.current) {
          history.push('/cs/agent-rollout');
        }
        showNotif({
          component: <ResultAlert data={resultData} />,
          kind: 'success',
          dismissAfter: 10000,
          type: 'dialog',
          onClose: hide
        });
      })
      .catch(err => {
        closeModal();
        if (!unmount.current) {
          console.log(err);
          history.push('/cs/agent-rollout');
          resultData.kind = 'error';
          showNotif({
            component: <ResultAlert data={resultData} />,
            kind: 'error',
            dismissAfter: 10000,
            type: 'dialog',
            onClose: hide
          });
        }
      });
  };

  const handleFilterInput = e => {
    setFilter({ ...filter, search: e.target.value, currentPage: 1 });
    setStartFilter(!startFilter);
  };

  // Keep the typed search when switching DR region (P81-132768).
  useRegionPersistedSearch(filter.search, value =>
    handleFilterInput({ target: { value } })
  );

  const handleFromTo = e => {
    const target = e.currentTarget;
    const name = target.getAttribute('field');
    if (target.id === name) {
      setFilter({
        ...filter,
        [name]: {
          ...filter[name],
          [`from`]: '',
          [`to`]: ''
        }
      });
      setStartFilter(!startFilter);
    } else {
      if (!validationNumber(target.value)) {
        setFilter({
          ...filter,
          [name]: {
            ...filter[name],
            [target.name]: target.value
          }
        });
        setStartFilter(!startFilter);
      }
    }
  };

  const handleFilterButton = () => {
    setFilterButton(!filterButton);
  };

  const handleLimitChange = limit => {
    if (filter.itemsPerPage === limit) {
      return;
    }
    setFilter({ ...filter, itemsPerPage: limit, currentPage: 1 });
    setStartFilter(!startFilter);
  };

  const handleSortable = field => () => {
    if (field === filter.fieldName) {
      const directionTemp = filter.direction * -1;
      setFilter({ ...filter, direction: directionTemp });
      setStartFilter(!startFilter);
    } else {
      setFilter({ ...filter, fieldName: field });
      setStartFilter(!startFilter);
    }
  };

  const changeCurrentPage = e => {
    setFilter({ ...filter, currentPage: e });
    setStartFilter(!startFilter);
  };

  // a function to check if the saved filters have a given combination of
  // the selected options and if so, switch to the saved filter

  const onClearSearch = () => {
    setFilter({ ...filter, search: '' });
    setStartFilter(!startFilter);
  };

  useEffect(() => {
    if (!agent) {
      history.push('/cs/agent-rollout');
    }
    return () => {
      unmount.current = true;
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!agent || agent.platform === 'linux') {
      return;
    }

    const linkForRequest = `/cs/agents/versions/list?page=1&limit=${versionsDefaultNavigation.itemsPerPage}`;
    const REQ_BODY = createVersionsReqBody({
      ...versionsDefaultFilters,
      ...versionsDefaultNavigation,
      platform: [agent.platform],
      releaseTracks: RELEASE_TRACKS
    });

    postRequest(linkForRequest, REQ_BODY)
      .then(res => {
        if (!unmount.current) {
          setTrackHolders(res.body.data);
        }
      })
      .catch(err => {
        !unmount.current && console.log(err);
      });
  }, [agent]);

  const getFilterOptionsFromBackend = listFilter => {
    setSelectLoader(true);
    getRequest('/cs/agents/customers/list/filters')
      .then(res => {
        if (!unmount.current) {
          const { body } = res;
          setFilters({ ...filters, ...body });
          // we are checking or in the new filter lists there are
          // parameters that are selected, and those that are not, turn off the selection
          const newCheckingList = checkingForExistenceOfOptions(
            listFilter,
            setFilter,
            body
          );
          newCheckingList && setPrevStateFilter(newCheckingList);
          newCheckingList &&
            replaceHistory(
              filter,
              undefined,
              history,
              'validation',
              newCheckingList,
              changeFilter,
              parsConfigForHistory(tableConf)
            );
          setSelectLoader(false);
        }
      })
      .catch(err => {
        !unmount.current && console.log(err);
      });
  };

  useEffect(() => {
    if (agent) {
      //after the select is closed, we get into this function.
      //We check or after closing the filter whether there have
      //been changes in the selected options and if so, we make a request
      if (triggerStartEffect) {
        if (
          (!isEqual(prevStateFilter, filter) &&
            JSON.parse(query.get('filter')) !== null) ||
          !isEqual(
            parsConfigForHistory(prevStateTableConf),
            parsConfigForHistory(tableConf)
          )
        ) {
          replaceHistory(
            filter,
            // setEnabledRequest,
            undefined,
            history,
            false,
            false,
            changeFilter,
            parsConfigForHistory(tableConf)
          );
        }
      }
      setTriggerStartEffect(true);
    }
    // eslint-disable-next-line
  }, [startFilter, tableConf]);

  useEffect(() => {
    if (agent) {
      // if (enabledRequest) { // were need for mode validation to clear some value in select
      setLoaderTable(true);
      if (
        query.get('filter') === null &&
        isEqual(filter, {
          ...defaultFilters,
          ...defaultNavigation
        })
      ) {
        replaceHistory(
          filter,
          // setEnabledRequest,
          undefined,
          history,
          'replace',
          false,
          'Default',
          parsConfigForHistory(tableConf)
        );
        setVisibleFilterEdit(false);
        setVisibleFilterSave(false);
        setPrevStateFilter(filter);
        setPrevStateTableConf(tableConf);
        requestForFilteredData();
      } else if (
        query.get('filter') === null &&
        !isEqual(filter, {
          ...defaultFilters,
          ...defaultNavigation
        })
      ) {
        resetAllfilters(true);
        replaceHistory(
          filter,
          // setEnabledRequest,
          undefined,
          history,
          'replace',
          {
            ...defaultFilters,
            ...defaultNavigation
          },
          'Default',
          tableConf
        );
        setVisibleFilterEdit(false);
        setVisibleFilterSave(false);
      } else {
        setFilter(JSON.parse(query.get('filter')));
        setPrevStateFilter(JSON.parse(query.get('filter')));
        setPrevStateTableConf(
          reParsConfigForHistory(JSON.parse(query.get('tableConf')))
        );
        requestForFilteredData(JSON.parse(query.get('filter')));
        setChangeFilter(query.get('changeFilter'));
        setTableConf(
          reParsConfigForHistory(
            JSON.parse(query.get('tableConf')),
            mainTableConf
          )
        );
      }
      setTrigerResetDatePicker(!trigerResetDatePicker);
      // }
      // setEnabledRequest(true);
    }
    // eslint-disable-next-line
  }, [query.get('filter')]);

  const requestForFilteredData = (listFilter = filter) => {
    const linkForRequest = `/cs/agents/customers/list?page=${listFilter.currentPage}&limit=${listFilter.itemsPerPage}`;
    const REQ_BODY = createReqBody(listFilter);

    postRequest(linkForRequest, REQ_BODY)
      .then(res => {
        if (!unmount.current) {
          setData(res.body);
          setDataConection(true);
          setLoader(false);
          setLoaderTable(false);
          getFilterOptionsFromBackend(listFilter);
        }
      })
      .catch(err => {
        if (!unmount.current) {
          setDataConection(false);
          setLoader(false);
          setLoaderTable(false);
          console.log(err);
        }
      });
  };

  const resetAllfilters = (
    reload,
    onlyFilterLabel,
    onClickDefault,
    modeClearAll
  ) => {
    const newValueFilters = clearOrDefaultFilters(modeClearAll, defaultFilters);

    setFilter({ ...newValueFilters, ...defaultNavigation });

    if ((changeFilter === 'Default' || onClickDefault) && !modeClearAll) {
      setVisibleFilterSave(false);
      setVisibleFilterEdit(false);
      setTableConf(JSON.parse(JSON.stringify(mainTableConf)));
    } else {
      setVisibleFilterSave('button');
      if (changeFilter !== 'Default') {
        setVisibleFilterEdit(true);
      }
    }
    if (!onlyFilterLabel) {
      setChangeFilter('Default');
      setTableConf(JSON.parse(JSON.stringify(mainTableConf)));
    }

    setTrigerResetDatePicker(!trigerResetDatePicker);
    if (!reload) {
      setStartFilter(!startFilter);
    }
  };

  if (loader) {
    return <Loading />;
  }

  if (!dataConection) {
    return <EmptyState message="connect" />;
  }

  return (
    <>
      <PageTitle title={'Agent Rollout'} />
      <Text className={classes.subtitle}>
        Select customers which will be rollout to a selected version
      </Text>
      <TableTitle
        className={classes.subtitle}
        title={`${t('activity:agentRollout.SELECTED_VERSION')}:`}
      />

      {agent && (
        <AgentInfo
          data={agent}
          isNotFiltered={testToIsNotFiltered()}
          isVisibleButtons={selectedCustomers.length < 1}
          handleCancel={handleCancel}
          handleRollout={handleRollout}
          handleSetAsDefault={handleSetAsDefault}
          handleSetVersionTrack={handleSetVersionTrack}
          trackHolders={trackHolders}
          buildIds={buildIds}
        />
      )}
      <div className={classes.filters_main}>
        <InputSearch
          placeholder={t('activity:filters.COMPANY_NAME_ID_PLACEHOLDER')}
          value={filter.search}
          onChange={handleFilterInput}
          onClearSearch={onClearSearch}
          className={classes.filter}
          disabled={loaderTable}
        />
        <FilterButton active={filterButton} onClick={handleFilterButton} />
        <SaveFilterBlock
          setFilterButton={setFilterButton}
          visibleFilterSave={visibleFilterSave}
          setVisibleFilterSave={setVisibleFilterSave}
          visibleFilterEdit={visibleFilterEdit}
          setVisibleFilterEdit={setVisibleFilterEdit}
          filter={filter}
          setFilter={setFilter}
          filterBackend={filterBackend}
          setFilterBackend={setFilterBackend}
          changeFilter={changeFilter}
          setChangeFilter={setChangeFilter}
          resetAllfilters={resetAllfilters}
          defaultNavigation={defaultNavigation}
          trigerResetDatePicker={trigerResetDatePicker}
          setTrigerResetDatePicker={setTrigerResetDatePicker}
          startFilter={startFilter}
          setStartFilter={setStartFilter}
          defaultFilters={defaultFilters}
          tableConf={tableConf}
          defaulTableConf={mainTableConf}
          setTableConf={setTableConf}
          triggerSaveTableSettings={triggerSaveTableSettings}
        />
      </div>
      <FiltersBlock
        filter={filter}
        setFilter={setFilter}
        startFilter={startFilter}
        setStartFilter={setStartFilter}
        filters={filters}
        filterButton={filterButton}
        trigerResetDatePicker={trigerResetDatePicker}
        resetAllfilters={resetAllfilters}
        selectLoader={selectLoader}
        setVisibleFilterSave={setVisibleFilterSave}
        setVisibleFilterEdit={setVisibleFilterEdit}
        changeFilter={changeFilter}
      />
      <div className={classes.actions}>
        <TableTitle title={'Customers'} additional={data.totalRecords} />
        <div className={classes.actions_right}>
          <TableColumnSetting
            setFilterButton={setFilterButton}
            tableConf={tableConf}
            setTableConf={setTableConf}
            setVisibleFilterSave={setVisibleFilterSave}
            setVisibleFilterEdit={setVisibleFilterEdit}
            changeFilter={changeFilter}
            visibleFilterSave={visibleFilterSave}
            visibleFilterEdit={visibleFilterEdit}
            setTriggerSaveTableSettings={setTriggerSaveTableSettings}
            triggerSaveTableSettings={triggerSaveTableSettings}
            defaulTableConf={mainTableConf}
            position="left"
          />

          <LimitPaginationButton
            currentLimit={filter.itemsPerPage}
            onLimitChange={handleLimitChange}
          />
        </div>
      </div>
      <div style={paddingForMenuSettings(tableConf, tableHeight)}>
        <div ref={tableHeight}>
          <RolloutCustomersTable
            data={data.data}
            handleSortable={handleSortable}
            loader={loaderTable}
            tableConf={tableConf}
            filter={filter}
            handleFromTo={handleFromTo}
            handleCheckCustomer={handleCheckCustomer}
            isSelectedCustomer={isSelectedCustomer}
            handleChekBox={handleChekBox}
            selectedCustomers={selectedCustomers}
          />
        </div>
        {data.data && loaderTable === false && data.totalPages > 1 && (
          <PaginationGroup
            pageCount={data.totalPages}
            setPage={changeCurrentPage}
            currentPage={filter.currentPage}
            itemsTotal={data.totalRecords}
            itemsPerPage={filter.itemsPerPage}
          />
        )}
        {selectedCustomers.length > 0 && (
          <FooterModalCustomers
            counter={selectedCustomers.length}
            handleCancel={handleCancel}
            handleRollout={handleRollout}
          />
        )}
      </div>
    </>
  );
};

export default RolloutCustomers;
